export class GymAddress {
  street: string;
  streetNumber: string;
  city: string;
  stateOrProvince: string;
  zipCode: string;
  country: string;
  coordinates: number[];
}
